// extracted by mini-css-extract-plugin
export default {"mapTooltip":"MapTooltip_mapTooltip__r-Bj-","mapTooltipArrow":"MapTooltip_mapTooltipArrow__OlT+S"};